var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature"},[_c('router-link',{attrs:{"to":`/article/${_vm.data.id}`}},[_c('div',{staticClass:"feature-title"},[_c('span',{staticClass:"foverlay"},[_vm._v(_vm._s(_vm.data.title))])]),_c('img',{attrs:{"src":_vm.data.img}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }